<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-dedication element-without-heading" id="vol-001-dedication">
<div class="text" id="vol-001-dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">Simon, Alexia and Gabriella – my biggest fans.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Love you always</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001dedication.vue?751651d2